export default __webpack_public_path__ + "static/media/REAL CPI ASSET STIKER-14.67f13e3d.png";